import  {apis,request,methods} from "../request";
export const httpCategory = ()=>{
    return request(methods.get,apis.getCategories)
 }